<template>
	<div class="c-view">
		<InternalHeader>
			<div slot="title" class="c-internal-header__title">
				Due Today
			</div>
			<div slot="actions">
				<ownership-toggle
					slot="actions"
					v-bind:value.sync="owner"
					class="mr-2"
				></ownership-toggle>
			</div>
		</InternalHeader>
		<progress-bar
			class="mt-5"
			:total="total"
			:completed="completed"
		></progress-bar>
		<div class="c-activities-list__column mt-5">
			<activities-list
				v-if="loaded"
				:class="'c-activities-list '"
				:activities="todayActivities"
				:show-progress="true"
				@check="handleCheck"
			>
			</activities-list>
			<loading-component v-else></loading-component>
		</div>
	</div>
</template>

<script>
export default {
	title: "Activities",
	props: {
		activitiesRepository: {
			type: Object,
			default: () => {
				return new (require("@/js/repositories/activities.js"))();
			},
		},
	},
	components: {
		ActivitiesList: function() {
			return import("@/js/components/partials/activities-list");
		},
		InternalHeader: function() {
			return import("@/js/components/partials/header");
		},
		OwnershipToggle: function() {
			return import("@/js/components/partials/tasks-ownership-toggle");
		},
		ProgressBar: function() {
			return import("@/js/components/partials/progress-bar");
		},
	},
	created() {
		this.$root.$on("activity:deleted", this.removeActivity);
		this.$root.$on("activity:skipped", this.removeActivity);
		this.$root.$on("activity:updated", this.replaceActivity);
		this.init();
	},
	data() {
		return {
			initialized: false,
			activities: [],
			perPage: 100,
			loaded: false,
			owner: "owner",
			localStorageKeyOwner: "activities_owner",
		};
	},
	computed: {
		total() {
			return this.activities.length;
		},
		completed() {
			let x = this.activities.reduce((r, activity) => {
				return r + +(activity.status_id === 2);
			}, 0);
			return x;
		},
		todayActivities() {
			let todayActivities = [];
			if (!this.activities) {
				return [];
			}
			this.activities.forEach((element) => {
				if (
					this.$moment(element.scheduled_at).format("YYYY-MM-DD") ==
						this.$moment()
							.utc()
							.format("YYYY-MM-DD") &&
					_.find(this.overdueActivities, { id: element.id }) ==
						undefined
				) {
					todayActivities.push(element);
				}
			});
			return todayActivities;
		},
	},
	methods: {
		/**
		 * Leave this without async. We want to retrieve these three lists
		 * in parallel
		 */
		init() {
			this.initializeOwner();
			this.load();
		},
		initializeOwner() {
			var owner = this.$localStorageCache.get(this.localStorageKeyOwner);
			this.owner = owner || "owner"; // mine, unassigned
			this.$watch("owner", this.onOwnerChange, { deep: true });
		},
		onOwnerChange() {
			this.$localStorageCache.set(this.localStorageKeyOwner, this.owner);
			this.load();
		},
		replaceActivity(activity) {
			let index = this.activities.findIndex(
				(oldActivity) => oldActivity.id == activity.id
			);
			this.activities.splice(index, 1, activity);
		},
		async handleCheck(activity) {
			var response = await this.activitiesRepository.update(
				activity.id,
				activity
			);

			this.$Message.success({
				content: "Activity Saved.",
			});
		},
		async load() {
			var finished = false;
			this.activities = [];
			this.page = 1;
			while (!finished) {
				var response = await this.query();
				this.activities.push(...response.data.data);
				finished = _.get(response, "data.links.next") ? false : true;
				++this.page;
			}
			this.loaded = true;
		},
		query() {
			let request = {
				params: {
					q: [
						"status_id[in]=1,2",
						"type_id[in]=1,3,4,9",
						"parent_activity_id[null]",
						"scheduled_at[gte]=" +
							this.$moment()
								.utc()
								.format("YYYY-MM-DD"),
						"scheduled_at[lt]=" +
							this.$moment()
								.utc()
								.add(1, "days")
								.format("YYYY-MM-DD"),
					],
					include: ["playbookAction.playbook", "account", "contact"],
					count: [
						"attachments",
						"subactivities",
						"subactivitiescompleted",
						"comments",
						"activityusers",
					],
					per_page: this.perPage,
					page: this.page,
				},
			};

			// Append ownership filter
			if (this.owner == "owner") {
				request.params.q.push(
					"assigned_to_id[eq]=" + this.$store.getters["me/ID"]
				);
			}

			return this.activitiesRepository.index(request);
		},
		async removeActivity(activityId) {
			let index = this.activities.findIndex(
				(activity) => activity.id == activityId
			);
			if (index >= 0) this.activities.splice(index, 1);
		},
	},
};
</script>
